var map = {
	"./absa.theme.json": 847,
	"./access.theme.json": 848,
	"./boa.theme.json": 849,
	"./co-operative.theme.json": 850,
	"./crdb.theme.json": 851,
	"./credit-bank.theme.json": 852,
	"./discount-capital.theme.json": 853,
	"./dtb.theme.json": 854,
	"./gapstack.theme.json": 855,
	"./i&m.theme.json": 856,
	"./kcb-bank.theme.json": 857,
	"./mhb.theme.json": 858,
	"./ncba.theme.json": 859,
	"./nmb.theme.json": 860,
	"./premier.theme.json": 861,
	"./primebank.theme.json": 862,
	"./qnb.theme.json": 863,
	"./sbm.theme.json": 864,
	"./sidian.theme.json": 865,
	"./stanbic.theme.json": 866,
	"./uba.theme.json": 867,
	"./umb.theme.json": 868,
	"./victoria-bank.theme.json": 869,
	"./zenith.theme.json": 870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 846;